import { useEffect } from "react";

const setMeta = (selector, attribute, name, content) => {
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, name);
    document.head.appendChild(tag);
  }

  tag.setAttribute("content", content);
};


function Seo({ title, description, image, url }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      setMeta('meta[name="description"]', "name", "description", description);
      setMeta('meta[property="og:description"]', "property", "og:description", description);
    }

    if (title) setMeta('meta[property="og:title"]', "property", "og:title", title);
    if (image) setMeta('meta[property="og:image"]', "property", "og:image", image);
    if (url) setMeta('meta[property="og:url"]', "property", "og:url", url);
  }, [title, description, image, url]);

  return null;
}

export default Seo;
